import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-stat',
  templateUrl: './stat.component.html',
  styleUrls: ['./stat.component.scss']
})
export class StatComponent implements OnInit {

  @Input() title: string | undefined;
  @Input() value: any | undefined;
  @Input() icon: string | undefined;
  @Input() percentage: string | undefined;
  @Input() profit: string | undefined;
  @Input() description: string | undefined;


  constructor() { }

  ngOnInit(): void {
  }

}
